import { render, staticRenderFns } from "./CustomerBestsellerProducts.vue?vue&type=template&id=142529f6&"
import script from "./CustomerBestsellerProducts.vue?vue&type=script&lang=ts&"
export * from "./CustomerBestsellerProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports